import './CustomerCareCard.css';
import React, { useContext } from 'react';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import InjectHTML from '../../DAcCreateAccount/components/InjectHTML';
import { ReactComponent as ChevronRight } from '../../../resources/icons/iconChevronRightCollapsed.svg';
const CustomerCareCard = props => {
  const {
    cardTitle,
    cardIcon,
    cardIconCode,
    phone,
    phoneTitle,
    description,
    cardLink
  } = props;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(Link, {
    field: {
      href: cardLink.jss.value.url,
      target: cardLink.jss.value.target,
      title: cardTitle.jss.value
    },
    className: `contact-card ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-card__info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-card__icon"
  }, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: cardIconCode.jss.value
  })), /*#__PURE__*/React.createElement("h5", {
    className: "contact-card__title"
  }, cardTitle.jss.value), /*#__PURE__*/React.createElement("p", {
    className: "contact-card__value"
  }, phoneTitle.jss.value), /*#__PURE__*/React.createElement("p", {
    className: "contact-card__subtitle"
  }, description.jss.value)), /*#__PURE__*/React.createElement("div", {
    className: "contact-card__arrow"
  }, /*#__PURE__*/React.createElement(ChevronRight, null)));
};
export default CustomerCareCard;
const commonStyles = "ct8rwat";
const ltrStyles = "l19g7saw";
const rtlStyles = "r16twp1n";